import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbTime;
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ClassUtils } from "abweb/utils/ClassUtils";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";

/**
 * Provides methods for working with AbTimeData structs
 */
export class AbTime {
  static fromData(data) {
    return new AbTime({
      hour: data.hour,
      minute: data.minute ?? 0,
      second: data.second ?? 0,
      millisecond: data.millisecond ?? 0
    });
  }
  static toDate(data) {
    const rawHHMMSS = new Date(); // always in current browser timezone
    rawHHMMSS.setHours(data.hour);
    rawHHMMSS.setMinutes(data.minute ?? 0);
    rawHHMMSS.setSeconds(data.second ?? 0);
    rawHHMMSS.setMilliseconds(data.millisecond ?? 0);
    return rawHHMMSS;
  }
  static fromDate(date) {
    return new AbTime({
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: date.getSeconds(),
      millisecond: date.getMilliseconds()
    });
  }
  static format(data, formatter) {
    const time = AbTime.toDate(data);
    return formatter.format(time);
  }

  // Returns Error if unable to parse
  static parse(dateStr, parser) {
    const time = parser.parse(dateStr);
    return ClassUtils.isInstanceOf(time, Error) ? time // Error
    : AbTime.fromDate(time);
  }
  constructor(_data) {
    _defineProperty(this, "formatLocalizedTime", () => {
      // TODO millisecond resolution
      const time = AbTime.toDate(this);
      return this.second === 0 ? DateTimeUtils.TIME_WITH_MINUTES.format(time) // minute resolution
      : DateTimeUtils.TIME_WITH_SECONDS.format(time); // second resolution
    });
    _defineProperty(this, "format", formatter => {
      const time = AbTime.toDate(this);
      return formatter.format(time);
    });
    _defineProperty(this, "toString", () => {
      return `[AbTime ${this.hour.toString().padStart(2, "0")}:${this.minute.toString().padStart(2, "0")}:${this.second.toString().padStart(2, "0")}.${this.millisecond.toString().padStart(3, "0")}]`;
    });
    _defineProperty(this, "equals", other => this.hour === other.hour && this.minute === (other.minute ?? 0) && this.second === (other.second ?? 0) && this.millisecond === (other.millisecond ?? 0));
    this._data = _data;
  }
  get hour() {
    return this._data.hour;
  }
  get minute() {
    return this._data.minute ?? 0;
  }
  get second() {
    return this._data.second ?? 0;
  }
  get millisecond() {
    return this._data.millisecond ?? 0;
  }
}
_AbTime = AbTime;
_defineProperty(AbTime, "MIN_TIME", _AbTime.fromData({
  hour: 0
}));
_defineProperty(AbTime, "MAX_TIME", _AbTime.fromData({
  hour: 23,
  minute: 59,
  second: 59,
  millisecond: 999
}));
_defineProperty(AbTime, "equals", (t1, t2) => {
  if (t1 === undefined && t2 === undefined) return true;
  if (t1 === undefined || t2 === undefined) return false;
  return _AbTime.fromData(t1).equals(t2);
});
//# sourceMappingURL=AbTime.js.map
